export const MARKETING_URL = 'https://triton.fish/';
export const ABOUT_C4ADS_URL = 'https://c4ads.org/about-us/';
export const ABOUT_TRITON_URL = 'https://triton.fish/about/';
export const TERMS_URL = 'https://triton.fish/terms/';
export const PRIVACY_URL = 'https://c4ads.org/privacy-policy/';
export const LICENSE_URL = 'https://app.triton.fish/eula';
export const CHANGELOG_URL = 'https://triton.launchnotes.io/';
export const REQUEST_ACCESS_URL = 'https://triton.fish/#contact-us';
export const ABOUT_URL = 'https://triton.fish/';
